import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PostulanteService } from '../../../services/postulante.service';
import { Postulante } from '../../../models/Postulante';


@Component({
  selector: 'app-FormPostulante',
  templateUrl: './FormPostulante.component.html',
  styleUrls: ['./FormPostulante.component.css']
})
export class FormPostulanteComponent implements OnInit {

  intereses = ["Angular", "React", "Vue", "Rubi on Rails"];
  postulante: Postulante = new Postulante();

  constructor(
    private postulanteService: PostulanteService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.cargarPostulante();
  }

  cargarPostulante(){
    this.activatedRoute.params.subscribe( params =>{
      let id = params['id'];
      if(id){
        this.postulanteService.traerPostulante(id).subscribe( res => {
          this.postulante = res;
        })
      }
    })
  }

  crearPostulante(){
    this.postulanteService.crearPostulante(this.postulante).subscribe(
      response => {
        this.router.navigate(['/postulantes']);
      }
    )

  }

  actualizarPostulante(){
    this.postulanteService.actualizarPostulante(this.postulante).subscribe(
      postulante => {
        this.router.navigate(['/postulantes']);
      }
    )
    console.log(this.postulante);
  }

  

}
